
import { Dialog } from "element-ui"

export default {
  name: "TipsDialog",
  components: {
    [Dialog.name]: Dialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    cancelText: {
      type: String,
      default: ""
    },
    confirmText: {
      type: String,
      default: ""
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lang: "",
      curVisible: this.visible
    }
  },
  watch: {
    visible(val) {
      this.curVisible = val
    }
  },
  mounted() {
    this.lang = this.$i18n.locale
  },
  methods: {
    handleClose() {
      this.$emit("cancel")
    },
    handleConfirm() {
      this.$emit("confirm")
    }
  }
}
